module.exports = __webpack_public_path__ + "static/media/1more-stylish-true-wireless.5d5da4d8.jpg";